/* eslint-disable no-useless-escape */
import React, { Component } from "react";
import "../../assets/scss/summary.scss";
import Drawer from "@material-ui/core/Drawer";
import Discounted from "../small-components/Discounted/discounted";
import DuplicateTemplate from "../small-components/DuplicateTemplate/duplicate-template";
import SaveTemplate from "../small-components/SaveTemplate/SaveTemplate";
import SettingTemplate from "../small-components/SettingTemplate/SettingTemplate";
import DeleteTemplate from "../small-components/DeleteTemplates";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import PermContactCalendarOutlinedIcon from "@material-ui/icons/PermContactCalendarOutlined";
import StarIcon from "@material-ui/icons/Star";
import IconButton from "@material-ui/core/IconButton";
import ReplyIcon from "@material-ui/icons/Reply";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DomainIcon from "@material-ui/icons/Domain";
import ImagePlus from "../../assets/images/plus.svg";
import EditIconOutlined from "@material-ui/icons/EditOutlined";
import DeleteIconOutlined from "@material-ui/icons/DeleteOutlined";
import SelectMenu from "./SelectMenu";
import "../../assets/scss/autocomplete.scss";
import TextField from "@material-ui/core/TextField/TextField";
import DateRangeIcon from "@material-ui/icons/DateRange";
import HeightIcon from "@material-ui/icons/Height";
import Estimate_Setting from "../../assets/images/setting-1.svg";
import { Typography } from "@material-ui/core";
import Estimate_Setting_pink from "../../assets/images/setting_pink.svg";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Sticky from "react-sticky-el";

import NumberFormat from "react-number-format";
import AlertDialog from "../small-components/AlertDialog/AlertDialog";
import ChipsArray from "../small-components/chips";
import fire from "../../config/firebase";
import { withRouter } from "react-router-dom";
import AutoCompleteOrganizations from "./autoComplete/autoCompleteOrganizations";
import EstimateCalculation from "../small-components/Phase/estimateCalculationUtil";
import FormatHour from "../../libs/formatHour";
import formatMoneyStrFriendly from "../../libs/formatMoneyStrFriendly";
import formatMoneyTimeBased from "../../libs/formatMoneyTimeBased";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

class EstimateFor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      right: false,
      overlayType: "",
      dotClick: false,
      dotClick1: false,
      dotClick2: false,
      profitType: "%",
      profit_select: false,
      anchorEl: false,
      durationPopup: false,
      inputField: true,
      featured: false,
      dialogOpen: false,
      phaseKey: 0,
      deleteType: "",
      formatType: "days",
      newTitle: "",
      users: [],
      userEmail: "",
      favoriteestimate: [],
      resetDiscount: false,
      people: "",
      organization: "",
      name: "",
      organizations: [],
      contacts: [],
      allTags: [],
      estimates: {},
      company: {},
      viewType: '%',
      projectName: null
    };
    this.wrapperRef = React.createRef();
    this.wrapperRef1 = React.createRef();
    this.wrapperRef2 = React.createRef();

    this.refreshData = this.refreshData.bind(this);
    this.updateEstimate = this.updateEstimate.bind(this);
  }
  componentDidMount = () => {
    this.refreshData();
  };
  componentWillReceiveProps(newProps) {
    if (newProps.update !== this.props.update) {
      this.refreshData();
    }
  }

  async refreshData() {
    this.props.updateFn();
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const reftagList = fire.database().ref("tags");
    const snapshotTag = await reftagList.once("value");
    const tags = snapshotTag.val();
    reftagList.off("value");
    const allTags = [];
    for (const id in tags) {
      allTags.push({ id, ...tags[id] });
    }

    const ref = fire.database().ref(dataType).child(key);
    const refsnapshot = await ref.once("value");
    const estimates = refsnapshot.val() || {};
    ref.off("value");

    const refCompany = fire.database().ref("company");
    const companySnapshot = await refCompany.once("value");

    const company = companySnapshot.val();
    refCompany.off("value");
    const calculations = (company.arrayItem || []).map((autocalculation) => {
      autocalculation.figure = parseInt(autocalculation.figure);
      return autocalculation;
    });

    //get reources from firebase
    const refEstimate = fire.database().ref("resources");
    refEstimate.off("value");

    const userListRef = fire.database().ref("users");
    const userSnap = await userListRef.once("value");
    const users = userSnap.val();
    userListRef.off("value");
    const userlist = [];
    for (const id in users) {
      userlist.push({ id, database: "users", ...users[id] });
    }

    const orgsRef = fire.database().ref("organizations");
    const orgSnap = await orgsRef.once("value");
    const orgs = orgSnap.val();
    orgsRef.off("value");

    const orgsList = [];
    for (const id in orgs) {
      orgsList.push({ id, database: "organizations", ...orgs[id] });
    }
    const peopleRef = fire.database().ref("people");
    const peopleSnap = await peopleRef.once("value");
    const contacts = peopleSnap.val();
    peopleRef.off("value");
    const contactList = [];
    for (const id in contacts) {
      if (contacts[id].archive !== "true") {
        contactList.push({ id, database: "people", ...contacts[id] });
      }
    }

    this.setState({
      contacts: contactList,
      users: userlist,
      tags: estimates.tags || [],
      people: estimates.people,
      organization: estimates.organization,
      estimates: estimates,
      allTags,
      organizations: orgsList,
      company,
      calculations,
    });
    //Current User
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          userEmail: user.email,
        });
      }
    });
  }

  handleBillableChange = (data) => {
    this.updateEstimate(data, true);
  };

  discountView = (type) => {
    this.setState({
      viewType: type,
    });
    this.dotOpen();
  };

  updateEstimate(updateData, refreshData = true) {
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const estimateRef = fire.database().ref(`${dataType}/${key}`);
    const newEstimateData = Object.assign({}, updateData);
    estimateRef.update(newEstimateData);

    if (refreshData) {
      this.refreshData();
    }
  }

  dotOpen = () => {
    this.setState({ anchorEl: true });
    const currentState = this.state.dotClick;
    this.setState({ dotClick: !currentState });
  };
  dotOpen1 = () => {
    const currentState = this.state.dotClick1;
    this.setState({ dotClick1: !currentState });
  };
  toggleDrawer = (anchor, open, type) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({
      ...this.state,
      [anchor]: open,
      overlayType: type,
      dotClick: false,
    });
  };
  durationMenu = () => {
    const currentState = this.state.durationPopup;
    this.setState({ durationPopup: !currentState });
  };
  deletePopup = (e) => {
    this.setState({
      dialogOpen: true,
      phaseKey: e,
      deleteType: "navlink",
    });
  };
  deleteHandler = () => {
    this.updateEstimate({
      discountType: null,
      discountValue: 0
    })
    this.setState({
      dialogOpen: false
    });
  };
  closeHandler = () => {
    this.setState({
      dialogOpen: false,
    });
  };
  updateBreadcrumb = (value) => {
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    // this.setState({ newTitle: value });
    // $("#link-breadcrumb a").text(value);
    // localStorage.setItem("projectName", value.slice(0, 25));
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const currentEstimate = fire.database().ref(dataType + "/" + key);
    currentEstimate.update({
      projectName: value,
    });
    this.refreshData();
    this.setState({ projectName: value });
  };
  handleFormat = (e) => {
    this.setState({ formatType: e });
  };
  optionAction = (e) => {
    this.setState({ ...this.state, right: true, overlayType: e.toLowerCase() });
  };
  handleFavorite = () => {
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    for (let i = 0; i < this.state.users.length; i++) {
      if (this.state.users[i]["caption"] === this.state.userEmail) {
        const userID = this.state.users[i]["id"];
        let favoriteestimate = [];
        if (this.state.users[i]["favoriteestimate"]) {
          favoriteestimate = this.state.users[i]["favoriteestimate"];
        }
        let recentExist = 0;
        const recentExistIndex = 0;
        this.setState({ favoriteestimate: favoriteestimate });
        if (this.state.users[i]["favoriteestimate"]) {
          favoriteestimate = this.state.users[i]["favoriteestimate"];
          for (let k = 0; k < favoriteestimate.length; k++) {
            if (favoriteestimate[k] && key === favoriteestimate[k]["id"]) {
              recentExist = 1;
            }
          }
        }
        if (recentExist === 1) {
          favoriteestimate.splice(recentExistIndex, 1);
          const userRef = fire.database().ref("users").child(userID);
          userRef.update({
            favoriteestimate: favoriteestimate,
          });
        }
        if (recentExist === 0) {
          favoriteestimate.unshift({ id: key });
          const userRef = fire.database().ref("users").child(userID);
          userRef.update({
            favoriteestimate: favoriteestimate,
          });
        }
      }
    }
    if (this.props.updateFn) {
      this.props.updateFn();
    }
  };

  handleCloseEditScreen = () => {
    if (this.props.closeEditScreen) {
      this.props.closeEditScreen("close");
    }
  };

  render() {
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const isTimebased = this.props.match.path.includes("timebased");

    const isTemplate = dataType === "templates";

    const contact = this.state.people;
    let favorite = false;
    for (let i = 0; i < this.state.users.length; i++) {
      if (this.state.users[i]["caption"] === this.state.userEmail) {
        if (this.state.users[i]["favoriteestimate"]) {
          const { favoriteestimate = [] } = this.state.users[i];
          favorite =
            favoriteestimate.find((d) => d && d.id === key) !== undefined;
        }
      }
    }
    const { estimates = {}, company = {}, calculations = [] } = this.state;
    let { projectName = '' } = estimates;
    if (this.state.projectName) {
      projectName = this.state.projectName
    }

    let startDate = null;
    let endDate = null;
    const getDateFromStr = (str) => {
      const dateParts = str.split(" ")[0].split("-");
      return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    };
    if (isTimebased) {
      if (estimates && estimates.phases) {
        for (const phase of estimates.phases) {
          if (phase.tasks) {
            for (const task of phase.tasks) {
              if (task.resources) {
                for (const resource of task.resources) {
                  if (resource.start_date) {
                    const curStartDate = getDateFromStr(resource.start_date);
                    if (
                      startDate === null ||
                      startDate.getTime() > curStartDate.getTime()
                    ) {
                      startDate = curStartDate;
                    }
                  }
                  if (resource.end_date) {
                    const currentEndDate = getDateFromStr(resource.end_date);
                    const correctDay = new Date(currentEndDate.getTime());
                    correctDay.setDate(currentEndDate.getDate() - 1);
                    if (endDate === null || endDate.getTime() < correctDay.getTime()
                    ) {
                      endDate = correctDay;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    const { discountType = null } = estimates;
    const { viewType = discountType } = this.state;
    const billableSwitch =
      estimates.billableSwitch || company.billableSwitch || false;

    let { discountValue = 0 } = estimates;

    const discountFomatted = (() => {
      let formatValue = "";
      if (discountType === "%" && discountValue) {
        formatValue = Math.round(discountValue);
      }
      if (discountType === "" && discountValue) {
        formatValue = Math.round(discountValue);
      } else {
        const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (specialChars.test(discountValue)) {
          discountValue = discountValue.replace(/[^a-zA-Z0-9]/g, "");
        }
        const roundValue = Math.round(discountValue || 0);
        formatValue = roundValue
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return formatValue;
    })();
    const estimateCalculator = new EstimateCalculation(estimates, calculations);
    const totalEstimatePrice = estimateCalculator.totalEstimatePrice();
    const totalEstimateCost = estimateCalculator.totalEstimateCost();
    const totalEstimateHours = estimateCalculator.totalEstimateHours();

    const totalEstimateProfit = estimateCalculator.totalEstimateProfit();
    const totalEstimateProfitPercentage =
      estimateCalculator.totalEstimateProfitPercentage();
    const afterDiscountPrice =
      totalEstimatePrice - estimateCalculator.getDiscountValue();

    let marginColor = "#db263b";

    const targetMargin = parseInt(
      this.state.estimates.targetMargin || this.state.company.targetMargin || 0
    );
    const vendorUpSell = parseInt(
      this.state.estimates.vendorUpSell || this.state.company.vendorUpSell || 0
    );

    if (billableSwitch) {
      if (
        totalEstimateProfitPercentage > targetMargin &&
        totalEstimateProfitPercentage > vendorUpSell
      ) {
        marginColor = "#65a838";
      } else {
        marginColor = "#db263b";
      }
    }
    const getDiff = (timeUnit) => {
      if (!startDate || !endDate) {
        return "";
      }
      const Difference_In_Time = endDate.getTime() - startDate.getTime();
      const DifferenceInDays = Difference_In_Time / (1000 * 3600 * 24);
      if (timeUnit === "week") {
        return Math.floor(DifferenceInDays / 7) + " Weeks";
      }
      return (DifferenceInDays / 30).toFixed(1) + " Months";
    };
    const getMMDD = (d) => {
      if (!d) {
        return "";
      }
      return (
        d.toLocaleString("default", { month: "short" }) + " " + d.getDate()
      );
    };
    const showDiscount = () => {
      const { viewType = discountType } = this.state;
      if (discountType === "%") {
        if (viewType === "%") {
          return discountFomatted + discountType;
        }
        const disNum = (estimateCalculator.getDiscountValue()).toLocaleString()
        return `$${disNum}`;
      }

      if (discountType === "$") {
        if (viewType === "$") {
          return discountType + discountFomatted;
        }
        if (!totalEstimatePrice || totalEstimatePrice <= 0) {
          return `0%`;
        }
        return (
          (
            (100 * estimateCalculator.getDiscountValue()) /
            totalEstimatePrice
          ).toFixed(1) + "%"
        );
      }

      if (discountType == "") {
        if (viewType == "0") {
          return discountType + discountFomatted;
        }
        if (!totalEstimatePrice || totalEstimatePrice <= 0) {
          return `0`;
        }
        const disNum = estimateCalculator.getDiscountValue()
        return `${disNum}`;

      }
    };

    const billableRate = parseFloat(estimates?.definedhourlyRate) || totalEstimateHours ? totalEstimatePrice / totalEstimateHours : 0;

    return (
      <div className="summary" key={key}>
        <div className="container" style={{ maxWidth: "1330px", padding: "0" }}>
          <div className="row top-content">
            <div className="col l2 top-content ">
              <span className="title">
                <Typography variant="h6" component="h6">
                  {this.props.title + (isTemplate ? " Template" : " Estimate")}
                </Typography>
              </span>
              <span className="violator-ribbon">
                <Typography variant="h6" component="h6">
                  {this.props.title + " Template"}
                </Typography>
              </span>
              <div className="directives">
                <IconButton
                  className="new-featured"
                  onClick={this.handleFavorite}
                >
                  {favorite ? (
                    <StarIcon htmlColor="#2ab7ca" />
                  ) : (
                    <svg
                      className="featured"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 22 20.9"
                    >
                      <path
                        fillRule="evenodd"
                        d="M9.909 9.793L13 2.5l3.091 7.293 7.909.671-6.006 5.2L19.8 23.4 13 19.3l-6.8 4.1L8 15.667l-6-5.203zm4.158.869L13 8.143l-1.067 2.5-.517 1.221-1.32.11-2.717.226 2.068 1.793 1 .869-.3 1.3-.616 2.651 2.336-1.413L13 16.723l1.133.7 2.332 1.408-.616-2.651-.3-1.3 1-.869 2.068-1.793-2.717-.225-1.32-.11z"
                        transform="translate(-2 -2.5)"
                      />
                    </svg>
                  )}
                </IconButton>
                <a href="">
                  <ReplyIcon htmlColor="#000" className="mirror-reply" />
                </a>
                <span className="setting-wrap">
                  <img
                    src={Estimate_Setting}
                    onClick={this.toggleDrawer("right", true, "setting")}
                    alt="setting"
                  />
                  <img
                    src={Estimate_Setting_pink}
                    onClick={this.toggleDrawer("right", true, "setting")}
                    alt="settings"
                  />
                </span>
                <span className="drawer_menu_button">
                  <SelectMenu
                    isTemplate={isTemplate}
                    optionAction={this.optionAction}
                    keyite={key}
                    toggleDrawer={this.toggleDrawer}
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="row row-wrap-counting">
            <div className="col l12 s12 m12 ">
              <div
                className={`main-title-wrap`}
              >
                <TextField
                  id="project_title"
                  variant="outlined"
                  //maxLength={10}
                  type="text"
                  // label="Estimate Name"
                  label={
                    dataType == "templates"
                      ? "Template Name"
                      : "Estimate Name"
                  }
                  value={projectName}
                  onChange={(e) => this.updateBreadcrumb(e.target.value)}
                />
              </div>

              <div className="row tag-row">
                <div className="col l8">
                  <div className="company-name">
                    <div className="inner-title-wrap">
                      <AutoCompleteOrganizations
                        key={this.state.organization + key + "organization"}
                        dataKey={key}
                        title={"organization"}
                        table="organizations"
                        contactType="Organization"
                        tableKey="organization"
                        update={(orgData) => {
                          this.updateEstimate(orgData);
                        }}
                        selectValue={this.state.organization}
                        options={this.state.organizations}
                      />
                      <DomainIcon className="company_icon" />
                    </div>
                  </div>
                  <div className="client-name">
                    <div className="inner-title-wrap">
                      <AutoCompleteOrganizations
                        key={this.state.organization + key + "people"}
                        dataKey={contact}
                        title={"Contact"}
                        table="people"
                        contactType="People"
                        tableKey="people"
                        update={(contactData) => {
                          this.updateEstimate(contactData);
                        }}
                        selectValue={contact}
                        options={this.state.contacts}
                      />
                      <PermContactCalendarOutlinedIcon className="client_icon" />
                    </div>
                  </div>
                  <div className="tag-name" ref={this.wrapperRef2}>
                    <ChipsArray
                      dataType={dataType}
                      tagsList={this.estimates?.tags || []}
                      refreshData={this.refreshData}
                      allTags={this.state.allTags}
                      itemId={key}
                      key={key}
                    />
                  </div>
                </div>
                <div className="col l4">
                  <div
                    className={
                      this.state.dotClick
                        ? "active discount-item"
                        : "discount-item"
                    }
                  >
                    <span
                      style={{
                        width: "100%",
                        padding: "16px 20px 14px 20px",
                        borderRadius: "5px",
                        backgroundColor: "rgba(8, 77, 79, 0.05)",
                        color: "#084d4f",
                      }}
                    >
                      DISCOUNT{" "}
                      {discountType !== null ? (
                        <React.Fragment>
                          <span className="discount-added">
                            {showDiscount()}
                          </span>

                          <MoreVertIcon
                            className="profit-dots"
                            onClick={this.dotOpen}
                            ref={this.wrapperRef1}
                          />
                          {this.state.dotClick && (
                            <ClickAwayListener
                              onClickAway={() =>
                                this.setState({ dotClick: false })
                              }
                            >
                              <ul>
                                {viewType === "%" ? (
                                  <li onClick={() => this.discountView("$")}>
                                    <AttachMoneyIcon />
                                    View as USD
                                  </li>
                                ) : (
                                  <li
                                    onClick={() => {
                                      this.discountView("%");
                                    }}
                                  >
                                    <span>%</span>
                                    View as Percentage
                                  </li>
                                )}
                                <li
                                  onClick={this.toggleDrawer(
                                    "right",
                                    true,
                                    "discount"
                                  )}
                                >
                                  <EditIconOutlined />
                                  Edit Discount
                                </li>
                                <li
                                  onClick={() => {
                                    this.setState({
                                      dialogOpen: true,
                                      dotClick: false
                                    });
                                  }}
                                >
                                  <DeleteIconOutlined />
                                  Delete
                                </li>
                              </ul>
                            </ClickAwayListener>
                          )}
                        </React.Fragment>
                      ) : (
                        <img
                          style={{
                            width: "20px",
                            height: "20px",
                            right: "22px",
                            top: "14px",
                            position: "absolute",
                            cursor: "pointer",
                          }}
                          src={ImagePlus}
                          alt="plus"
                          onClick={this.toggleDrawer("right", true, "discount")}
                        />
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <Sticky
                topOffset={-77}
                stickyClassName={"calcSticky"}
                boundaryElement="header"
                relative="true"
                top='94px'
              >
                <div className="row">
                  <div className="col l8 countings">
                    {isTimebased && (

                      <div className="date-wrap">
                        <Typography variant="h6" component="h6">
                          START & END
                        </Typography>
                        <span>
                          {this.state.formatType === "days"
                            ? getMMDD(startDate) + " - " + getMMDD(endDate)
                            : this.state.formatType === "weeks"
                              ? getDiff("week")
                              : getDiff("month")}
                        </span>

                        <span className="open-dots">
                          <MoreVertIcon
                            htmlColor="#e70a89"
                            onClick={this.durationMenu}
                          />{" "}
                        </span>
                        {this.state.durationPopup && (

                          <ClickAwayListener onClickAway={this.durationMenu}>
                            <div className="menu-item">
                              <div className="upper-grid active">
                                <span className="icon-outer">
                                  <DateRangeIcon htmlColor="#e70a89" />
                                </span>
                                <span className="text-box"> Start & End </span>
                              </div>
                              <div className="lower-grid">
                                <span className="icon-outer">
                                  <HeightIcon />
                                </span>
                                <span className="text-box"> Duration </span>
                                <List component="nav" className="nav-outer">
                                  <ListItem
                                    className={`${this.state.formatType === "days"
                                      ? "active"
                                      : ""
                                      }`}
                                  >
                                    <ListItemText
                                      primary="Days"
                                      onClick={() => this.handleFormat("days")}
                                    />
                                  </ListItem>
                                  <ListItem
                                    className={`${this.state.formatType === "weeks"
                                      ? "active"
                                      : ""
                                      }`}
                                  >
                                    <ListItemText
                                      primary="Weeks"
                                      onClick={() => this.handleFormat("weeks")}
                                    />
                                  </ListItem>
                                  <ListItem
                                    className={`${this.state.formatType === "months"
                                      ? "active"
                                      : ""
                                      }`}
                                  >
                                    <ListItemText
                                      primary="Months"
                                      onClick={() => this.handleFormat("months")}
                                    />
                                  </ListItem>
                                </List>
                              </div>
                            </div>
                          </ClickAwayListener>
                        )}
                      </div>

                    )}
                    <div className="hour-wrap">
                      <Typography variant="h6" component="h6">
                        Hours
                      </Typography>
                      <span>{FormatHour({ number: totalEstimateHours })}</span>
                    </div>
                    <div className="cost-wrap">
                      <Typography variant="h6" component="h6">
                        Cost
                      </Typography>
                      <span>
                        {formatMoneyTimeBased({
                          number: totalEstimateCost,
                          money: true,
                          maximumFractionDigits: 0,
                        })}
                      </span>
                    </div>
                    <div className="bill-wrap">
                      <Typography variant="h6" component="h6">
                        BILLING RATE
                      </Typography>
                      <span>
                        {!billableSwitch
                          ? "N/A"
                          : formatMoneyStrFriendly({
                            number: isNaN(billableRate) ? 0 : billableRate,
                            perTitle: "/hr",
                            money: true,
                            maximumFractionDigits: 0,
                          })}
                        {/* FormatMoney(estimates.definedhourlyRate ? estimates.definedhourlyRate : (totalEstimatePrice / totalEstimateHours), "/hr")} */}
                      </span>
                    </div>
                    <>
                      <div
                        className={
                          this.state.dotClick1
                            ? "active profit-margin"
                            : "profit-margin"
                        }
                      >
                        <Typography variant="h6" component="h6">
                          Profit Margin
                        </Typography>
                        <span
                          //color: '#65a838'
                          style={{ color: marginColor }}
                        >
                          {billableSwitch !== true ? (
                            "N/A"
                          ) : (
                            <>
                              {this.state.profitType === "$"
                                ? "$" + ((totalEstimateProfit).toFixed(0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : ""}
                              {this.state.profitType === "%"
                                ? totalEstimateProfitPercentage + "%"
                                : ""}
                            </>
                          )}
                        </span>
                        <MoreVertIcon
                          className="profit-dots"
                          onClick={this.dotOpen1}
                          ref={this.wrapperRef}
                        />
                        {this.state.dotClick1 && (
                          <ClickAwayListener
                            onClickAway={() =>
                              this.setState({ dotClick1: false })
                            }
                          >
                            <ul>
                              <li
                                onClick={() => this.setState({ profitType: "$" })}
                                className={
                                  this.state.profitType === "$" ? "active" : ""
                                }
                              >
                                <AttachMoneyIcon />
                                View as USD
                              </li>
                              <li
                                onClick={() => this.setState({ profitType: "%" })}
                                className={
                                  this.state.profitType === "%" ? "active" : ""
                                }
                              >
                                <span>%</span>
                                View as Percentage
                              </li>
                            </ul>
                          </ClickAwayListener>
                        )}
                      </div>
                    </>
                  </div>
                  <div
                    className={`col l4 total ${this.state.defaultTotal !== totalEstimatePrice
                      ? "discountAdded"
                      : ""
                      }`}
                  >
                    <div>
                      <h6>TOTAL</h6>
                      <h2>
                        <NumberFormat
                          id="discount"
                          displayType={"text"}
                          isNumericString={true}
                          thousandSeparator={true}
                          value={afterDiscountPrice.toFixed(0).slice(0, 10)}
                          prefix={"$"}
                        />
                      </h2>
                      {afterDiscountPrice.toFixed(0) ===
                        totalEstimatePrice.toFixed(0) ? null : (
                        <h5>
                          <strike>
                            <NumberFormat
                              id="no_discount"
                              displayType={"text"}
                              isNumericString={true}
                              thousandSeparator={true}
                              value={
                                this.state.defaultTotal !== totalEstimatePrice &&
                                totalEstimatePrice.toFixed(0).slice(0, 10)
                              }
                              prefix={"$"}
                            />
                          </strike>
                        </h5>
                      )}
                    </div>
                  </div>
                </div>
              </Sticky>
            </div>
          </div>
          <Drawer
            anchor={"right"}
            open={this.state.right}
            onClose={this.toggleDrawer("right", false)}
          >
            {this.state.overlayType === "discount" ? (
              <Discounted
                key={key}
                onClose={this.toggleDrawer("right", false)}
                discountApplied={this.discountApplied}
                estimates={estimates}
                price={totalEstimatePrice}
                resetDiscount={this.state.resetDiscount}
                update={this.updateEstimate}
              />
            ) : null}
            {this.state.overlayType === "duplicate" ? (
              <DuplicateTemplate
                originalName={estimates?.name || null}
                projectName={"(copy of) " + this.props.match.params.projectName}
                onClose={this.toggleDrawer("right", false)}
              />
            ) : this.state.overlayType === "save" ? (
              <SaveTemplate
                dataKey={key}
                closeEditScreen={this.handleCloseEditScreen}
                dataType={dataType}
                onClose={this.toggleDrawer("right", false)}
              />
            ) : null}
            {this.state.overlayType === "setting" ? (
              <SettingTemplate
                key={key}
                refreshData={this.refreshData}
                onClose={this.toggleDrawer("right", false)}
                updateEstimate={this.updateEstimate}
                currentProfit={totalEstimateProfitPercentage}
                estimates={estimates}
                company={company}
              />
            ) : null}
            {this.state.overlayType === "delete" ? (
              <DeleteTemplate
                name={this.props.match.params.projectName}
                onClose={this.toggleDrawer("right", false)}
                dataKey={key}
              />
            ) : null}
          </Drawer>
        </div>
        <AlertDialog
          open={this.state.dialogOpen}
          onClose={this.closeHandler}
          phaseKey={this.state.phaseKey}
          keyValue={this.deleteHandler}
          deleteType={this.state.deleteType}
          name={"discount"} />
      </div>
    );
  }
}

export default withRouter(EstimateFor);
